import * as yup from 'yup';
import { IMetricFundDataModel } from '../data-models/metrics.data-model';
import { isoDateStringField } from './isoDateStringField';

/**
 * A deliberately basic schema of one `metrics.fundData` item: the scalar
 * fields only (customData omitted — dynamic keys have no vocabulary story).
 * First consumer is the formula-field vocabulary, which surfaces `fundData`
 * as a list a formula can REDUCE/SIZE/INDEX over; the `satisfies` clause
 * keeps every key honest against IMetricFundDataModel.
 */
export const MetricsFundDataSchema = {
  base() {
    return {
      acquisitionDate: isoDateStringField(),
      acquisitionShares: yup.number(),
      amountInvested: yup.number(),
      companyId: yup.number(),
      convertedOwnership: yup.number(),
      convertedSharesHeld: yup.number(),
      currentCost: yup.number(),
      dilutionAssumption: yup.number(),
      distributions: yup.number(),
      entryOwnership: yup.number(),
      exitDate: isoDateStringField(),
      exitOwnership: yup.number(),
      exitOwnershipPercentage: yup.number(),
      exitType: yup.string(),
      exitValuation: yup.number(),
      fmv: yup.number(),
      fmvBasis: yup.number(),
      followOnInvestment: yup.number(),
      fundId: yup.number(),
      id: yup.number(),
      impliedEquityValue: yup.number(),
      impliedOwnershipPercentage: yup.number(),
      initialInvestment: yup.number(),
      initialInvestmentRound: yup.string(),
      initialInvestmentRoundId: yup.number(),
      initialPostMoney: yup.number(),
      initialPreMoney: yup.number(),
      initialSharePrice: yup.number(),
      initialSharesHeld: yup.number(),
      interest: yup.number(),
      irr: yup.number(),
      moic: yup.number(),
      netMoic: yup.number(),
      netTotalValue: yup.number(),
      noOfShares: yup.number(),
      ownerShipPercentage: yup.number(),
      ownershipSource: yup.string(),
      percentOfFmv: yup.number(),
      percentOfFund: yup.number(),
      percentTotalValue: yup.number(),
      projectedExitTiming: yup.string(),
      projectedMOIC: yup.number(),
      projectedProceeds: yup.number(),
      realizedGLCostBasis: yup.number(),
      realizedValueCostBasis: yup.number(),
      recyclableCapital: yup.number(),
      reserves: yup.number(),
      rtfe: yup.number(),
      stockProceeds: yup.number(),
      totalGL: yup.number(),
      totalGLWithEscrow: yup.number(),
      unrealizedGLCostBasis: yup.number(),
      unrealizedPps: yup.number(),
      unrealizedValueCostBasis: yup.number(),
    } satisfies Partial<Record<keyof IMetricFundDataModel, yup.ISchema<unknown>>>;
  },
};
